/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccommodationCatalogItemDto } from './accommodation-catalog-item-dto';
import {
    AccommodationCatalogItemDtoFromJSON,
    AccommodationCatalogItemDtoFromJSONTyped,
    AccommodationCatalogItemDtoToJSON,
    AccommodationCatalogItemDtoToJSONTyped,
} from './accommodation-catalog-item-dto';

/**
 * Cursor page of catalog cards. The cursor is bound to the selected city.
 * @export
 * @interface AccommodationCatalogPageResponseDto
 */
export interface AccommodationCatalogPageResponseDto {
    /**
     * 
     * @type {Array<AccommodationCatalogItemDto>}
     * @memberof AccommodationCatalogPageResponseDto
     */
    items: Array<AccommodationCatalogItemDto>;
    /**
     * 
     * @type {string}
     * @memberof AccommodationCatalogPageResponseDto
     */
    nextCursor?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccommodationCatalogPageResponseDto
     */
    hasMore: boolean;
}

/**
 * Check if a given object implements the AccommodationCatalogPageResponseDto interface.
 */
export function instanceOfAccommodationCatalogPageResponseDto(value: object): value is AccommodationCatalogPageResponseDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('hasMore' in value) || value['hasMore'] === undefined) return false;
    return true;
}

export function AccommodationCatalogPageResponseDtoFromJSON(json: any): AccommodationCatalogPageResponseDto {
    return AccommodationCatalogPageResponseDtoFromJSONTyped(json, false);
}

export function AccommodationCatalogPageResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccommodationCatalogPageResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(AccommodationCatalogItemDtoFromJSON)),
        'nextCursor': json['nextCursor'] == null ? undefined : json['nextCursor'],
        'hasMore': json['hasMore'],
    };
}

  export function AccommodationCatalogPageResponseDtoToJSON(json: any): AccommodationCatalogPageResponseDto {
      return AccommodationCatalogPageResponseDtoToJSONTyped(json, false);
  }

  export function AccommodationCatalogPageResponseDtoToJSONTyped(value?: AccommodationCatalogPageResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(AccommodationCatalogItemDtoToJSON)),
        'nextCursor': value['nextCursor'],
        'hasMore': value['hasMore'],
    };
}

